import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "action-list"
}
const _hoisted_4 = {
  key: 1,
  class: "action-list"
}

import Pagination from '@/components/Pagination.vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import SelectBrand from '@/components/SelectBrand.vue'
import { getCurrentInstance, reactive, onActivated, onMounted, ref } from 'vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils/index'
import { getSpecialRuleListApi, getSpecialRuleCheckListApi, checkSpecialRuleApi, cancelSpecialRuleApi } from '@/apis/brand'
import { getSecondBrandListNoPageApi } from '@/apis/merchant-admin'
import { BrandCat } from '@/enums/brand'
import { UserType } from '@/enums/user'
import { ApprovalStatus, DeliveryType } from './enum'


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecialRuleList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const route = useRoute()
const router = useRouter()
const store = useStore()
const uploadRef = ref()
const userType = store.state.user.userInfo.user_type as number
const isCakeAccount = store.state.user.userInfo.is_cat // 是否为蛋糕商户：1-是，0-否

const filterCatType = ref('1')

const filters = reactive({
    brand_id:           '',     // 品牌id
    second_brand_id:    '',     // 二级品牌id
    approval_status:    '',     // 审核状态
    oper_status:        '',     // 生效状态
    title:              '',     // 商品名称
    delivery_type:      '',     // 配送类型
    cat_id:             '1',    // 分类id
    page:               1,      // 当前页码
    page_size:          10,     // 每页显示条数
    source:             route.meta.v, // 1-商户端，2-运营端
    is_business_open:   1,      // 是否营业：1-营业，2-不营业（此处与其他处和数据库不一致用于导出功能）
})
// 非蛋糕商户默认展示零食
if (UserType[userType] === '合作商户' && !isCakeAccount) {
    filterCatType.value = '5'
    filters.cat_id = '5'
}

const onCatChange = (key) => {
    if (key == '99') {
        filters.cat_id = ''
        filters.is_business_open = 2
    } else {
        filters.cat_id = key
        filters.is_business_open = 1
    }
    
    filterCatType.value = key
    onSearch()
}

const badgeMap = ref<any>({})
const tableData = ref([])
const total = ref(0)// 获取列表数据
const getList = async () => {
    let result
    if (filters.source == 1) {
        result = await getSpecialRuleListApi({
            ...filters,
            approval_status: filters.approval_status == '4' ? '' : filters.approval_status,
            oper_status: filters.approval_status == '4' ? '4' : filters.oper_status
        }) as any
    } else {
        result = await getSpecialRuleCheckListApi(filters) as any
    }

    const { code, data, msg } = result
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
    if (filters.source == 2) {
        badgeMap.value = data.cat_str
    }
}

// 批量上传弹窗
const batchAddDialog = ref(false)
const batchErrorMsg = ref('')
const onFileExceed = () => {
    proxy.$message({ type: 'error', message: '只能上传一个文件，请删除后重新上传' })
}
const onUploadSuccess= async (res) => {
    const { code, data, msg } = res
    if(code == 200) {
        proxy.$message({ type: 'success', message: msg })
        beforeAddDialogClosed()
        getList()
    } else {
        batchErrorMsg.value = msg
        // 清除上传队列，允许用户重新上传文件
        if(uploadRef.value) {
            uploadRef.value!.clearFiles()
        }
        proxy.$message({ type: 'error', message: msg })
    }
}
//确定上传
const dialogSubmit= () => {
    proxy.$refs.uploadRef.submit()
}
//打开上传更新弹窗
const batchAddDialogType = ref(1)
const openDialogNew = (type) => {
    batchAddDialogType.value = type
    batchAddDialog.value = true
}
// 关闭上传更新弹框
const beforeAddDialogClosed = () => {
    batchErrorMsg.value = ''
    //清除数据
    if(uploadRef.value){
        uploadRef.value!.clearFiles()
    }
    batchAddDialog.value = false
    getList()
}

// 跳转至编辑页
const toEdit = (t = 1, id = '', is_clone = 0) => {
    if (filters.source == 1) {
        router.push(`/merchant-admin/special-rule-edit?t=${t}&id=${id}&is_clone=${is_clone}`)
    } else {
        router.push(`/check/special-rule-edit?t=${t}&id=${id}&is_clone=${is_clone}`)
    }
}
const setOperStatus = () => { 
    router.push(`/merchant-admin/shop-logo`)
}
// 终止
const onCancel = (id) => {
    proxy.$confirm('确认要终止此条配规？', '提示', {
        type: 'warning'
    }).then(async () => {
        const { code, data, msg } = await cancelSpecialRuleApi(id) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        proxy.$message({ type: 'success', message: '成功' })
        // 菜单提醒数字减一
        // store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule')
        getList()
    }).catch(() => {
        console.log('取消')
    })
}

// 审核通过
const onPass = (rowData) => {
    const { id, start_date } = rowData
    if (new Date(start_date).getTime() < Date.now()) return proxy.$message({ type: 'error', message: '配规开始日期不能早于当前时间。请驳回，告知商户修改配规开始时间' })
    proxy.$confirm('确认要通过此条配规？', '提示', {
        type: 'warning'
    }).then(async () => {
        const { code, data, msg } = await checkSpecialRuleApi(id, 2) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        proxy.$message({ type: 'success', message: '成功' })
        // 菜单提醒数字减一
        // store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule')
        getList()
    }).catch(() => {
        console.log('取消')
    })
}
// 审核驳回
const rule_id = ref('') // 当前操作配规ID
const  reject_reason = ref('') // 驳回原因
const rejectDialog = ref(false)
const beforeRejectDialogClosed = () => {
    rule_id.value = ''
    reject_reason.value = ''
    rejectDialog.value = false
}
const onReject = async () => {
    if (!rule_id.value) return proxy.$message.error('未找到配规数据')
    if (!reject_reason.value) return proxy.$message.error('请填写驳回原因')
    const { code, data, msg } = await checkSpecialRuleApi(rule_id.value, 3, reject_reason.value) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '成功' })
    rejectDialog.value = false
    reject_reason.value = ''
    // 菜单提醒数字减一
    // store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule')
    getList()
}

const onExport = () => {
    window.open(`${Keys.baseUrl}//distribution/listDeliveryRule?${joinParams({user_id: store.state.user.userInfo.id})}&is_export=1`)
}
const onBrandChange = (val) => {
    filters.brand_id = val
    val && getSecondBrandList(val)
}

const secondBrandList = ref<any>([]) // 二级品牌列表
const getSecondBrandList = async (brand_id) => {
    const { code, data, msg } = await getSecondBrandListNoPageApi(brand_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    secondBrandList.value = data
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

onActivated(() => {
    const storageFilterCatType = sessionStorage.getItem('filterType') || ''
    if (!storageFilterCatType) return

    if (storageFilterCatType == '99') {
        filters.is_business_open = 2
        filters.cat_id = ''
        filterCatType.value = '99'
    } else {
        filters.cat_id = storageFilterCatType
        filterCatType.value = storageFilterCatType        
    }
    sessionStorage.removeItem('filterType')
    getList()
})
onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectBrand, { onBrandChange: onBrandChange }),
      (filterCatType.value != '99')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            class: "filter-item",
            modelValue: filters.second_brand_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.second_brand_id) = $event)),
            clearable: "",
            placeholder: "请选二级品牌"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondBrandList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.approval_status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.approval_status) = $event)),
        placeholder: "审核状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待审核",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "通过",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: "3"
          }),
          _createVNode(_component_el_option, {
            label: "已终止",
            value: "4"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (filters.source == 1)
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            class: "filter-item",
            modelValue: filters.oper_status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.oper_status) = $event)),
            clearable: "",
            placeholder: "请选择生效状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "未生效",
                value: 1
              }),
              _createVNode(_component_el_option, {
                label: "生效中",
                value: 2
              }),
              _createVNode(_component_el_option, {
                label: "已失效",
                value: 3
              }),
              _createVNode(_component_el_option, {
                label: "已终止",
                value: 4
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (filters.source == 2 && filterCatType.value == '1')
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 2,
            class: "filter-item",
            modelValue: filters.delivery_type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.delivery_type) = $event)),
            clearable: "",
            placeholder: "请选择配送类型"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "仅自提",
                value: _unref(DeliveryType)['仅自提']
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "仅配送",
                value: _unref(DeliveryType)['仅配送']
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "配送+自提",
                value: _unref(DeliveryType)['配送+自提']
              }, null, 8, ["value"]),
              _createVNode(_component_el_option, {
                label: "快递",
                value: _unref(DeliveryType)['快递']
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (filters.source == 1)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 3,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (toEdit(1)))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("添加特殊配规")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (filters.source == 1 && _unref(UserType)[_unref(userType)] === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 4,
            class: "filter-btn",
            type: "primary",
            onClick: onExport
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("全部导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (filters.source == 1 && _unref(UserType)[_unref(userType)] === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 5,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (openDialogNew(1)))
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("批量添加蛋糕/鲜花配规")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (filters.source == 1 && _unref(UserType)[_unref(userType)] === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 6,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (openDialogNew(2)))
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("批量添加零食配规")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (filters.source == 1 && _unref(UserType)[_unref(userType)] === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 7,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (openDialogNew(3)))
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("批量添加不营业配规")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (filters.source == 1 && _unref(UserType)[_unref(userType)] === '蛋叔员工')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 8,
            class: "filter-btn",
            type: "primary",
            onClick: setOperStatus
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("运营设置商城标识")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_menu, {
      "default-active": filterCatType.value,
      type: "border-card",
      mode: "horizontal",
      onSelect: onCatChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_badge, {
              value: badgeMap.value.cat_1,
              offset: [6, 15]
            }, {
              default: _withCtx(() => _cache[20] || (_cache[20] = [
                _createTextVNode("蛋糕")
              ])),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "5" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_badge, {
              value: badgeMap.value.cat_5,
              offset: [6, 15]
            }, {
              default: _withCtx(() => _cache[21] || (_cache[21] = [
                _createTextVNode("零食")
              ])),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "8" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_badge, {
              value: badgeMap.value.cat_8,
              offset: [6, 15]
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("鲜花")
              ])),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "99" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_badge, {
              value: badgeMap.value.closed || '',
              offset: [6, 15]
            }, {
              default: _withCtx(() => _cache[23] || (_cache[23] = [
                _createTextVNode("不营业商家")
              ])),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: "",
      "row-key": "id",
      class: "mt20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "rule_id",
          label: "配规ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_id",
          label: "品牌ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌名称"
        }),
        (filterCatType.value == '99')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_table_column, {
                prop: "cat_id",
                label: "品类"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_unref(BrandCat)[row.cat_id]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "门店",
                "show-overflow-tooltip": "",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.shop_names || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "状态" }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createTextVNode("不营业")
                ])),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "城市",
                "show-overflow-tooltip": "",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.city_name || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "start_date",
                label: "闭店开始日期",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "end_date",
                label: "闭店结束日期",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "配规描述",
                "show-overflow-tooltip": "",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.description || '--'), 1)
                ]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (filterCatType.value != '1')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: "二级品牌",
                    "show-overflow-tooltip": "",
                    width: "100"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.second_brand || '--'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                label: "商品",
                "show-overflow-tooltip": "",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.product_names || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "delivery_type",
                label: "配送类型"
              }),
              (filterCatType.value == '5')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    label: "是否发货"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.is_delivery_enabled ? '发货' : '不发货'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "start_date",
                label: "配规开始日期",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "end_date",
                label: "配规结束日期",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "城市",
                "show-overflow-tooltip": "",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.city_name || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "配规描述",
                "show-overflow-tooltip": "",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.description || '--'), 1)
                ]),
                _: 1
              }),
              (filterCatType.value == '1')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 2,
                    label: "配送时间段",
                    "show-overflow-tooltip": "",
                    width: "100"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.delivery_time || '--'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (filterCatType.value == '1')
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 3,
                    label: "自提时间段",
                    "show-overflow-tooltip": "",
                    width: "100"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createTextVNode(_toDisplayString(row.shop_delivery_time || '--'), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "ship_amount",
                label: "配送费(元)",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.ship_amount == '-1' ? '执行品牌运费' : row.ship_amount), 1)
                ]),
                _: 1
              })
            ], 64)),
        _createVNode(_component_el_table_column, { label: "审核状态" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.oper_status == '已终止' ? '已终止' : _unref(ApprovalStatus)[row.approval_status]), 1)
          ]),
          _: 1
        }),
        (filters.source == 1)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "oper_status",
              label: "生效状态"
            }))
          : _createCommentVNode("", true),
        (filters.source == 2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "submitted_at",
              label: "提交时间",
              width: "140"
            }))
          : _createCommentVNode("", true),
        (filters.source == 2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              label: "审核时间",
              width: "140"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.approved_at || '--'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "185",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            (filters.source == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    disabled: _unref(ApprovalStatus)[row.approval_status] != '驳回',
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toEdit(1, row.rule_id))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    disabled: _unref(ApprovalStatus)[row.approval_status] == '驳回' || row.oper_status == '已失效' || row.oper_status == '已终止',
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onCancel(row.rule_id))
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode("终止")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toEdit(1, row.rule_id, 1))
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode("克隆")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (toEdit(2, row.id))
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode("查看")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    disabled: _unref(ApprovalStatus)[row.approval_status] != '待审核',
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onPass(row))
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createTextVNode("通过")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"]),
                  _createVNode(_component_el_button, {
                    disabled: _unref(ApprovalStatus)[row.approval_status] != '待审核',
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => {rejectDialog.value = true;rule_id.value = row.id}
                  }, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createTextVNode("驳回")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "驳回",
      modelValue: rejectDialog.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((rejectDialog).value = $event)),
      "before-close": beforeRejectDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: beforeRejectDialogClosed }, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (onReject()))
        }, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "驳回原因",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: reject_reason.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((reject_reason).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量上传特殊配规",
      modelValue: batchAddDialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((batchAddDialog).value = $event)),
      "before-close": beforeAddDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: beforeAddDialogClosed }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogSubmit
        }, {
          default: _withCtx(() => _cache[38] || (_cache[38] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "inForm",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  action: `/api/distribution/doImportRule?type=${batchAddDialogType.value}&user_id=${_unref(store).state.user.userInfo.id}&user_name=${_unref(store).state.user.userInfo.username}`,
                  "on-exceed": onFileExceed,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx",
                  limit: 1,
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                (batchAddDialogType.value == 1)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      href: `${_unref(Keys).baseUrl}/distribution/downCakeRuleTemplate`
                    }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("下载批量添加蛋糕/鲜花类模版")
                      ])),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (batchAddDialogType.value == 2)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      href: `${_unref(Keys).baseUrl}/distribution/downSnackRuleTemplate`
                    }, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("下载批量添加零食类模版")
                      ])),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true),
                (batchAddDialogType.value == 3)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 2,
                      href: `${_unref(Keys).baseUrl}/distribution/downByyRuleTemplate`
                    }, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("下载批量添加不营业类模版")
                      ])),
                      _: 1
                    }, 8, ["href"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (batchErrorMsg.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_alert, {
                      title: batchErrorMsg.value,
                      type: "error",
                      closable: false
                    }, null, 8, ["title"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})